let AbstractLayer = require('./abstract');
let baseMapList = require('../../modules/constants/basemaps.js');

class BaseMapLayer extends AbstractLayer {
  constructor(params) {
    super(params);
    this.layer = create(params);
  }

  initStore(params) {
    this.store = {};
    this.store.id = params.id;
    this.store.layerType = "opengis.layers.baseMap";
    this.layer = {};
  }

  getItems() {
    return baseMapList.items();
  }

  getById(id) {
    return getBaseMapConfiguration(id);
  }
}

function create() {
  return baseMapList.items();
}

function getBaseMapConfiguration(id) {
  let baseMapsDictionary = baseMapList.items();
  let baseMap = baseMapsDictionary.find((item) => {
    return item.id === id;
  });
  return baseMap;
}

module.exports = BaseMapLayer;